module.exports = __webpack_public_path__ + "static/media/africaThumbnail.10c5b2dd.jpg";